import React, { Dispatch, SetStateAction } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { isCloverProdEnvironment, isCloverStagingEnvironment } from '../Environment';

const PROD_RECAPTCHA_SITE_KEY = '6LcvpW0nAAAAAMdjeor9kycixdFzk33K1G_hmOM_';
const DEV_RECAPTCHA_SITE_KEY = '6LfKcj4dAAAAAHZL0JDBy3T9PNQ7XMyzjg09X4Y-';
const STAGING_SITE_KEY = '6Lc4WGcpAAAAACld77sajhfyss_b5hmpaSJhAqZ2';

// https://jira.corp.clover.com/browse/CO-10070
export const getRecaptchaSiteKey = () => {
  const nonProdKey = isCloverStagingEnvironment() ? STAGING_SITE_KEY : DEV_RECAPTCHA_SITE_KEY;

  return isCloverProdEnvironment() ? PROD_RECAPTCHA_SITE_KEY : nonProdKey;
};

export const doRecaptcha = async (recaptchaRef: React.RefObject<ReCAPTCHA>, setShowPaymentApiError?: Dispatch<SetStateAction<boolean>>) => {
  let recaptchaToken;
  try {
    recaptchaToken = await recaptchaRef.current?.executeAsync();
    recaptchaRef.current?.reset(); //enabling recaptcha for subsequent checks
  } catch (e) {
    setShowPaymentApiError && setShowPaymentApiError(true);
    console.error('Payment failed cause of recaptcha issue');
  }

  return recaptchaToken;
};
